<div *ngIf="alert" class="mt-4" [ngClass]="{ hidden }">
    <div [ngClass]="alert.cssClass" [innerHTML]="alert.message"></div>
</div>